import { render, staticRenderFns } from "./generalCampaignData.vue?vue&type=template&id=5e3d8def&"
import script from "./generalCampaignData.vue?vue&type=script&lang=js&"
export * from "./generalCampaignData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports